var _palette$shadows;
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  paper: {
    maxWidth: 'none',
    width: 'fit-content'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 40,
    padding: '24px 32px 12px',
    background: palette.gradients.fade
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    '& .MuiSvgIcon-root': {
      width: 24,
      height: 24,
      flexShrink: 0,
      backgroundColor: 'transparent',
      borderRadius: 0,
      '& rect': {
        fill: 'transparent'
      }
    }
  },
  title: {
    fontWeight: 600
  },
  subtitle: {
    fontWeight: 600
  },
  close: {
    padding: 4,
    '& .MuiSvgIcon-root': {
      width: 24,
      height: 24
    }
  },
  content: {
    padding: '12px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& p': {
      whiteSpace: 'nowrap'
    }
  },
  footer: {
    '&.MuiDialogActions-root': {
      justifyContent: 'space-between',
      padding: '16px 32px'
    },
    '& .MuiButton-root': {
      marginBottom: 12
    }
  },
  cancelButton: {
    minWidth: 160,
    minHeight: 56,
    fontSize: '1.125rem',
    color: palette.primary.main,
    backgroundColor: palette.common.white,
    border: "1px solid ".concat(palette.shades[300]),
    boxShadow: (_palette$shadows = palette.shadows) === null || _palette$shadows === void 0 ? void 0 : _palette$shadows[1],
    '&:hover': {
      backgroundColor: palette.common.white
    }
  },
  confirmButton: {
    minWidth: 160,
    minHeight: 56,
    fontSize: '1.125rem',
    color: palette.common.white
  }
});
export default useStyles;